export default "__VITE_ASSET__DlE07LMW__"